import React from 'react';

import CircleSpinner from 'components/CircleSpinner';
import Row from 'components/Row';
import Text from 'components/Text';

export default function CSVUploadLoadingState(props: { text: string; longListWarning?: boolean }) {
  return (
    <div className="CSVUploadLoadingState">
      <Row size="small">
        <CircleSpinner size="large" />
      </Row>
      <Text color="mascot" size="large" data-test="loading-text">
        {props.text}
        {!!props.longListWarning && (
          <>
            <br />
            depending on your file size, this may take a while
          </>
        )}
      </Text>
    </div>
  );
}
